import { BlocksGameLogic } from '../logic/blocks-game-logic';
import { GameRound } from '../../common/phaser/model/game-round';
import { GameState, RoundType } from 'game-logic';
import { RoundParams } from '../../common/phaser/model/round-params';
import { RoundResultSubmitter } from '../../common/phaser/model/round-result-submitter';

export type OnGameStateChangedAction = (state: GameState) => void;

export class BlocksGameRound implements GameRound {
  public get roundType(): RoundType {
    return RoundType.Standard;
  }
  public get currentGame(): BlocksGameLogic {
    return this.gameLogic;
  }
  public get gameLogicActions() {
    return this.gameLogic.gameLogicActions;
  }
  public set onGameStateChangedAction(value: OnGameStateChangedAction) {
    this.gameStateChangedAction = value;
  }

  public readonly roundResultsSubmitter: RoundResultSubmitter;

  private gameLogic: BlocksGameLogic;
  private gameState: GameState;
  private sideEffectsSubmitted: boolean;
  private gameStateChangedAction?: OnGameStateChangedAction;

  constructor(gameLogic: BlocksGameLogic, roundParams: RoundParams) {
    this.gameLogic = gameLogic;
    this.gameState = GameState.Init;
    this.sideEffectsSubmitted = false;

    this.roundResultsSubmitter = roundParams.roundResultSubmitter;

    this.gameLogic.gameLogicActions.on('onGameLost', () => {
      this.setGameState(GameState.Finished);
      this.submitSideEffectsIfNeeded(false);
    });
    this.gameLogic.gameLogicActions.on('onGameAutoComplete', () => {
      this.setGameState(GameState.AutoFinish);
    });
    this.gameLogic.gameLogicActions.on('onGameCompleted', () => {
      this.setGameState(GameState.Finished);
      this.submitSideEffectsIfNeeded(true);
    });
    this.gameLogic.gameLogicActions.on('onFirstShapePlaced', () => {
      this.setGameState(GameState.InProgress);
    });
  }

  async submitSideEffectsIfNeeded(isComplete: boolean): Promise<void> {
    if (this.sideEffectsSubmitted) {
      return;
    }

    await this.roundResultsSubmitter.submitResult(this.gameLogic, isComplete);

    this.sideEffectsSubmitted = true;
  }

  public isFinished(): boolean {
    return this.sideEffectsSubmitted;
  }

  public onGameSetupAnimationFinished() {
    this.setGameState(GameState.InProgress);
  }

  private setGameState(gameState: GameState) {
    this.gameState = gameState;
    this.gameStateChangedAction?.(gameState);
  }
}
